export default __webpack_public_path__ + "static/media/1380.4b5a4ac7.png";